import { render } from "./NewAddressModal.vue?vue&type=template&id=5ac32308"
import script from "./NewAddressModal.vue?vue&type=script&lang=ts"
export * from "./NewAddressModal.vue?vue&type=script&lang=ts"
script.render = render

export default script